<template>
  <PlatformRenderer>
    <template v-slot:onMobile>
      <WCSinglePageFormContainer class="px-3">
        <WCSpinner v-if="loading" size="xl" position="center" />

        <template v-else>
          <WCChangePasswordForm @submit="submitChangePasswordForm" />
        </template>
      </WCSinglePageFormContainer>
    </template>

    <template v-slot:onDesktop>
      <DashboardWindow>
        <template v-slot:title>
          {{ $t('changePassword') }}
        </template>

        <template v-slot:body>
          <WCSpinner v-if="loading" size="xl" position="center" />

          <template v-else>
            <DashboardWindowSection>
              <h3>{{ $t('changeYourPassword') }}</h3>
              <div class="w-50">
                <WCChangePasswordForm @submit="submitChangePasswordForm" />
              </div>
            </DashboardWindowSection>
          </template>
        </template>
      </DashboardWindow>
    </template>
  </PlatformRenderer>
</template>

<script>
import axios from 'axios';
import PlatformRenderer from '@/modules/platform/components/PlatformRenderer';
import WCSinglePageFormContainer from '@/modules/forms/components/WCSinglePageFormContainer/WCSinglePageFormContainer.vue';
import DashboardWindow from '@/layouts/components/Dashboard/DashboardWindow.vue';
import DashboardWindowSection from '@/layouts/components/Dashboard/DashboardWindowSection.vue';
import WCChangePasswordForm from '@/modules/user/components/WCChangePasswordForm/WCChangePasswordForm.vue';
import WCSpinner from '@/components/WCSpinner/WCSpinner.vue';
import WCSimpleToast from '@/modules/toasts/components/WCSimpleToast/WCSimpleToast.vue';
import ToastService from '@/modules/toasts/services/ToastService';

export default {
  name: 'ChangePassword',
  components: {
    DashboardWindow,
    DashboardWindowSection,
    WCChangePasswordForm,
    WCSpinner,
    PlatformRenderer,
    WCSinglePageFormContainer,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async submitChangePasswordForm(form) {
      this.loading = true;
      const payload = {
        oldPassword: form.oldPassword,
        newPassword: form.password,
      };
      try {
        const response = await axios.post('api/me/password', payload);
        if (response.data.code === 0) {
          ToastService.open(WCSimpleToast, {
            props: {
              variant: 'info',
              title: 'Success! 🎉',
              message: 'Your password change was successful!',
            },
            timeout: 7000,
          });
        }
      } catch (error) {
        const response = error.response;
        const message =
          response && response.data && response.data.message
            ? response.data.message
            : 'Failed to change password';
        ToastService.open(WCSimpleToast, {
          props: {
            variant: 'danger',
            title: 'Error',
            message,
          },
          timeout: 7000,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
